import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { EVENTS } from '../events';
import { PROPERTIES } from '../properties';
import { EventTrackingServcie } from '../event-tracking.servcie';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { } // Use Injector to avoid cyclic dependency

  handleError(error: any): void {
    // Logged first and unconditionally — this is the only diagnostic trail
    // for an uncaught error, so it must never be skipped by a failure below
    // it (analytics.track() itself throwing, e.g. from a bad/missing
    // Amplitude config, used to silently swallow this entirely — and only
    // where analytics actually run, since EventTrackingServcie.track() is a
    // no-op unless environment.enableAmplitude is set).
    console.error('Global Error Captured:', error);

    try {
      const analytics = this.injector.get(EventTrackingServcie);
      const message = error?.message || error?.toString() || 'Unknown error';
      const stackTrace = error?.stack || 'No stack trace';

      analytics.track(EVENTS.ERROR_OCCURRED, {
        [PROPERTIES.USER_ID]: analytics['userId'],
        [PROPERTIES.MESSAGE]: message,
        [PROPERTIES.STACK_TRACE]: stackTrace,
        [PROPERTIES.TIMESTAMP]: new Date().toISOString(),
      });
    } catch (trackingError) {
      console.error('AppErrorHandler: failed to report error to analytics:', trackingError);
    }
  }
}
